import { ImageThumbnailRatio } from "@components/ImageThumbnailRatio";
import React from "react";
import { Fragment } from "react";

import styles from "../styles.module.scss";
import BigPictureNews from "./index";

const bullishImage = '/images/Bullish.png';
const bearishImage = '/images/Bearish.png';

const BigPictureNewsList = ({ posts, type, users }) => {

  const image = type === "BULLISH" ? bullishImage : bearishImage;
  
  return (
    <Fragment>
      <div className={styles["card-featured-news"]}>
        <ImageThumbnailRatio
          ratio="520:236"
          alt="bigPicture image"
          aria-label="bigPicture image"
          src={image}
          className={styles.bigPictureImage}
        />
        {posts.map((post) => (
          <BigPictureNews 
            key={post.id}
            post={post} 
            data={users}
          />
        ))}
      </div>
    </Fragment>
  );
};
export default BigPictureNewsList;
